import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  StyledDownArrow,
  StyledFilter,
  StyledFilterDropdown,
  StyledFilterItemsWrapper,
  StyledFiltersWrapper,
} from '../styles/FilterDropdown.styles';
import FilterCheckBox from '../../../atoms/FilterCheckBox/view/FilterCheckBox.view';
import { capitalizeFirstWordOfSentence } from '../../../../../../../utils/utils.web';
import QuickFilterTabs from '../../../atoms/QuickFilterTabs/views/QuickFilterTabs.view';
import QuickFilterList from '../../../atoms/QuickFilterList/views/QuickFilterList.view';
import {
  getAppliedFilterCount,
  getColorFilterOptionsMap,
  isShowQuickFilterTabs,
} from '../../../utils';
import ColorFilterPill from '../../../atoms/ColorFilterPill/views/ColorFIlterPill.view';
import PriceFilter from '../../../atoms/PriceFilter/views/PriceFilter.view';
import useQuickFilters from '../../../hooks/useQuickFilters';
import {
  CLOTHING_SIZE_FILTER,
  FIT_FILTER,
  SIZE_FILTER,
} from '../../../constants/QuickFilters.constants';

const FilterDropdown = ({
  filterValues,
  filterName,
  facetName,
  setUpdatedUrlActn,
  isFacetedNavigationEnabled,
  seoFacetedNavigationConfig,
  cleanUrlObj,
  pathName,
  formDetails,
  appliedFilters,
  filterMaps,
  setPriceFilterFlagActn,
  updateBopisFormValue,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropDownRef = useRef(null);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const [selectedTab, handleFilterSelection] = useQuickFilters({
    appliedFilters,
    formDetails,
    isFacetedNavigationEnabled,
    seoFacetedNavigationConfig,
    setUpdatedUrlActn,
    pathName,
    cleanUrlObj,
    setPriceFilterFlagActn,
    updateBopisFormValue,
  });

  const handleClickOutside = useCallback((e) => {
    if (dropDownRef.current && !dropDownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  let Component = FilterCheckBox;
  let options = filterValues;
  let quickFilterTabs = [];
  if (filterName?.toLowerCase() === 'color') {
    Component = ColorFilterPill;
    options = getColorFilterOptionsMap(filterValues, facetName);
  } else if (filterName?.toLowerCase() === 'price') {
    Component = PriceFilter;
    options = [filterValues[0]];
  } else if (facetName === SIZE_FILTER || facetName === CLOTHING_SIZE_FILTER) {
    quickFilterTabs = filterMaps[FIT_FILTER];
  }

  const appliedFilterCount =
    getAppliedFilterCount(appliedFilters, facetName) > 0
      ? `(${getAppliedFilterCount(appliedFilters, facetName)})`
      : '';

  return (
    <StyledFiltersWrapper
      ref={dropDownRef}
      onMouseLeave={(e) => {
        e.preventDefault();
        setIsDropdownOpen(false);
      }}
    >
      <StyledFilter onClick={toggleDropdown} isDropdownOpen={isDropdownOpen}>
        {`${capitalizeFirstWordOfSentence(filterName)} ${appliedFilterCount}`}
        <StyledDownArrow className={`${isDropdownOpen ? 'expanded' : ''}`} />
      </StyledFilter>
      <StyledFilterDropdown isVisible={isDropdownOpen}>
        {isShowQuickFilterTabs(facetName, quickFilterTabs) ? (
          <QuickFilterTabs
            tabs={quickFilterTabs}
            selectedTab={selectedTab}
            handleTabSelection={handleFilterSelection}
          />
        ) : null}
        <StyledFilterItemsWrapper isFilterTabs={isShowQuickFilterTabs(facetName, quickFilterTabs)}>
          <QuickFilterList
            RenderComponent={Component}
            setUpdatedUrlActn={setUpdatedUrlActn}
            isFacetedNavigationEnabled={isFacetedNavigationEnabled}
            seoFacetedNavigationConfig={seoFacetedNavigationConfig}
            cleanUrlObj={cleanUrlObj}
            pathName={pathName}
            formDetails={formDetails}
            options={options}
            appliedFilters={appliedFilters}
            facetName={facetName}
            filterMaps={filterMaps}
            handleFilterSelection={handleFilterSelection}
            filterName={filterName}
          />
        </StyledFilterItemsWrapper>
      </StyledFilterDropdown>
    </StyledFiltersWrapper>
  );
};

export default FilterDropdown;
